import { NgModule } from '@angular/core';
import { environment } from '@env';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { Effects } from './effects';
import { UI_PREFERENCES_REDUCER, UI_PREFERENCES_REDUCER_KEY } from './reducers';
import { AGGREGATION_REDUCER, AGGREGATION_REDUCER_KEY } from './reducers/aggregation.reducer';
import { APPS_REDUCER, APPS_REDUCER_KEY } from './reducers/apps.reducer';
import { AUTH_REDUCER, AUTH_REDUCER_KEY, RESET_PASSWORD_REDUCER, RESET_PASSWORD_REDUCER_KEY } from './reducers/auth.reducer';
import { AUTHORIZATION_SYSTEMS_REDUCER, AUTHORIZATION_SYSTEMS_REDUCER_REDUCER_KEY } from './reducers/authorization-systems.reducer';
import { BUNDLES_REDUCER, BUNDLES_REDUCER_KEY } from './reducers/bundles.reducer';
import { CUSTOM_REDUCER, CUSTOM_REDUCER_KEY } from './reducers/custom.reducer';
import { DASHBOARD_REDUCER, DASHBOARD_REDUCER_KEY } from './reducers/dashboard.reducer';
import { ENINVOICE_REDUCER, ENINVOICE_REDUCER_KEY } from './reducers/eninvoice.reducer';
import { GST_FILING_REDUCER, GST_FILING_REDUCER_KEY } from './reducers/gst-filing.reducer';
import { IDENTITY_PROVIDERS_REDUCER, IDENTITY_PROVIDERS_REDUCER_KEY } from './reducers/identity-providers.reducer';
import { INSTANCES_REDUCER, INSTANCES_REDUCER_KEY } from './reducers/instances.reducer';
import { INTEGRATIONS_REDUCER, INTEGRATIONS_REDUCER_KEY } from './reducers/integrations.reducer';
import { LOCATIONS_REDUCER, LOCATIONS_REDUCER_KEY } from './reducers/locations.reducer';
import { MANAGE_APPS_REDUCER, MANAGE_APPS_REDUCER_KEY } from './reducers/manage-apps.reducer';
import { MASTERS_REDUCER, MASTERS_REDUCER_KEY } from './reducers/master-management.reducer';
import { NOTIFICATION_PREFERENCES_REDUCER, NOTIFICATION_PREFERENCES_REDUCER_KEY } from './reducers/notification-preferences.reducer';
import { NOTIFICATIONS_REDUCER, NOTIFICATIONS_REDUCER_KEY } from './reducers/notifications.reducer';
import { ORCHESTRATION_ASSISTANT_REDUCER, ORCHESTRATION_ASSISTANT_REDUCER_KEY } from './reducers/orchestration-assistant.reducer';
import { PACKAGES_REDUCER, PACKAGES_REDUCER_KEY } from './reducers/packages.reducer';
import { PARTNER_REDUCER, PARTNER_REDUCER_KEY } from './reducers/partner.reducer';
import { PERMISSIONS_REDUCER, PERMISSIONS_REDUCER_KEY } from './reducers/permissions.reducer';
import { RECORDS_REDUCER, RECORDS_REDUCER_KEY } from './reducers/records.reducer';
import { REPORTS_REDUCER, REPORTS_REDUCER_KEY } from './reducers/reports.reducer';
import { REQUESTS_REDUCER, REQUESTS_REDUCER_KEY } from './reducers/requests.reducer';
import { ROLES_REDUCER, ROLES_REDUCER_KEY } from './reducers/roles.reducer';
import { SEARCH_REDUCER, SEARCH_REDUCER_KEY } from './reducers/search.reducer';
import { SEARCH_CRITERIA_REDUCER, SEARCH_CRITERIA_REDUCER_KEY } from './reducers/searchCriteria.reducer';
import { SESSION_REDUCER, SESSION_REDUCER_KEY } from './reducers/session.reducer';
import { SHARED_REDUCER, SHARED_REDUCER_KEY } from './reducers/shared.reducer';
import { TAGS_REDUCER, TAGS_REDUCER_KEY } from './reducers/tags.reducer';
import { TASKS_REDUCER, TASKS_REDUCER_KEY } from './reducers/tasks.reducer';
import { ACTIVE_TOKENS_REDUCER, ACTIVE_TOKENS_REDUCER_KEY } from './reducers/tokens.reducer';
import { TRANSFORMATIONS_REDUCER, TRANSFORMATIONS_REDUCER_KEY } from './reducers/transformations.reducer';
import { USERS_REDUCER, USERS_REDUCER_KEY } from './reducers/users.reducer';
import { WIDGET_REDUCER, WIDGET_REDUCER_KEY } from './reducers/widget.reducer';
import { WORKFLOW_REDUCER, WORKFLOW_REDUCER_KEY } from './reducers/workflow.reducer';

const REDUCERS = {
    [ACTIVE_TOKENS_REDUCER_KEY]: ACTIVE_TOKENS_REDUCER,
    [AGGREGATION_REDUCER_KEY]: AGGREGATION_REDUCER,
    [APPS_REDUCER_KEY]: APPS_REDUCER,
    [AUTH_REDUCER_KEY]: AUTH_REDUCER,
    [AUTHORIZATION_SYSTEMS_REDUCER_REDUCER_KEY]: AUTHORIZATION_SYSTEMS_REDUCER,
    [BUNDLES_REDUCER_KEY]: BUNDLES_REDUCER,
    [TASKS_REDUCER_KEY]: TASKS_REDUCER,
    [PACKAGES_REDUCER_KEY]: PACKAGES_REDUCER,
    [DASHBOARD_REDUCER_KEY]: DASHBOARD_REDUCER,
    [ENINVOICE_REDUCER_KEY]: ENINVOICE_REDUCER,
    [GST_FILING_REDUCER_KEY]: GST_FILING_REDUCER,
    [INSTANCES_REDUCER_KEY]: INSTANCES_REDUCER,
    [INTEGRATIONS_REDUCER_KEY]: INTEGRATIONS_REDUCER,
    [LOCATIONS_REDUCER_KEY]: LOCATIONS_REDUCER,
    [MANAGE_APPS_REDUCER_KEY]: MANAGE_APPS_REDUCER,
    [NOTIFICATION_PREFERENCES_REDUCER_KEY]: NOTIFICATION_PREFERENCES_REDUCER,
    [NOTIFICATIONS_REDUCER_KEY]: NOTIFICATIONS_REDUCER,
    [PARTNER_REDUCER_KEY]: PARTNER_REDUCER,
    [PERMISSIONS_REDUCER_KEY]: PERMISSIONS_REDUCER,
    [RECORDS_REDUCER_KEY]: RECORDS_REDUCER,
    [REQUESTS_REDUCER_KEY]: REQUESTS_REDUCER,
    [REPORTS_REDUCER_KEY]: REPORTS_REDUCER,
    [RESET_PASSWORD_REDUCER_KEY]: RESET_PASSWORD_REDUCER,
    [ROLES_REDUCER_KEY]: ROLES_REDUCER,
    [SEARCH_CRITERIA_REDUCER_KEY]: SEARCH_CRITERIA_REDUCER,
    [SESSION_REDUCER_KEY]: SESSION_REDUCER,
    [SHARED_REDUCER_KEY]: SHARED_REDUCER,
    [TAGS_REDUCER_KEY]: TAGS_REDUCER,
    [TRANSFORMATIONS_REDUCER_KEY]: TRANSFORMATIONS_REDUCER,
    [USERS_REDUCER_KEY]: USERS_REDUCER,
    [WIDGET_REDUCER_KEY]: WIDGET_REDUCER,
    [WORKFLOW_REDUCER_KEY]: WORKFLOW_REDUCER,
    [MASTERS_REDUCER_KEY]: MASTERS_REDUCER,
    [IDENTITY_PROVIDERS_REDUCER_KEY]: IDENTITY_PROVIDERS_REDUCER,
    [SEARCH_REDUCER_KEY]: SEARCH_REDUCER,
    [CUSTOM_REDUCER_KEY]: CUSTOM_REDUCER,
    [ORCHESTRATION_ASSISTANT_REDUCER_KEY]: ORCHESTRATION_ASSISTANT_REDUCER,
    [UI_PREFERENCES_REDUCER_KEY]: UI_PREFERENCES_REDUCER,
};

@NgModule({
    imports: [
        StoreModule.forRoot({ ...REDUCERS }),
        EffectsModule.forRoot(Effects),
        StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    ],
})
export class NgRXStoreModule {}
